$shm_hitalama_map_widget_float_form_custom $shm_hitalama_map_widget_float
	controls /
		<= Form $mol_form
			form_fields <= form_fields /
				<= Field*0 $mol_form_field
					name <= field_name* \
					Content <= Field_content* $mol_view
			buttons <= buttons /
				<= Publish $mol_button_major
					title \Отправить
					click? <=> submit? null
					enabled <= submit_allowed true
				<= Clear $mol_button_minor
					title \Очистить
					click? <=> clear? null
	custom $shm_hitalama_map_widget_entity_form_custom
	Content_by_type* *
		any
			<= String*
		string
			<= String* $mol_string
				value? <=> field_value*? null
		textarea
			<= Textarea* $mol_textarea
				value? <=> field_value*?
		date
			<= Date* $mol_date
				value? <=> field_value*?
		period
			<= Period* $shm_period
				period? <=> field_value*?
				period_str => period_str*
		file
			<= File* $shm_hitalama_file_attach
				files? <=> field_files*? /
	settings_content /
		<= Buttons_visible $mol_check_box
			title \Показывать кнопки
			checked? <=> buttons_visible? true
	-
		<= Buttons_visible $mol_view
			sub /
				<= Min_label $mol_paragraph
					title \Min
				<= Min $mol_number
					value? <=> min?
		<= Max_row $mol_view
			sub /
				<= Max_label $mol_paragraph
					title \Max
				<= Max $mol_number
					value? <=> max?
		<= Step_row $mol_view
			sub /
				<= Step_label $mol_paragraph
					title \Step
				<= Step $mol_number
					value? <=> step?
					precision 0.01
					precision_change 1
